const membershipPopulate = {populate: {member: {populate: ["profileImage"]}}};

export function buildWorkspaceMembershipListQuery(userId) {
    return {
        filters: {
            $and: [
                {member: {$eq: userId}},
            ],
        },
        fields: ["isDefault", "memberShipStatus", "workspaceConfigs"],
        populate: {
            workspace: true,
        },
        pagination: {
            pageSize: 100,
            withCount: false,
        },
    };
}

export function buildActiveWorkspaceContextQuery(userId) {
    return {
        populate: {
            member: {populate: ["profileImage"]},
            user_roles: {
                fields: ["role", "scope_id", "scope_type", "permissions"],
            },
            workspace: {
                populate: {
                    goals: {
                        filters: {
                            $and: [
                                {archivedAt: {$null: true}},
                            ],
                        },
                        populate: {
                            parentGoal: {
                                filters: {
                                    $and: [
                                        {archivedAt: {$null: true}},
                                    ],
                                },
                            },
                            owner: membershipPopulate,
                            team: true,
                        },
                    },
                    projects: {
                        filters: {
                            $and: [
                                {archivedAt: {$null: true}},
                                {
                                    $or: [
                                        {owner: {member: {$eq: userId}}},
                                        {members: {member: {$eq: userId}}},
                                        {
                                            workspace: {
                                                user_roles: {
                                                    $and: [
                                                        {workspace_membership: {member: {$eq: userId}}},
                                                        {role: {$eq: "owner"}},
                                                    ],
                                                },
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        populate: {
                            goals: true,
                            members: membershipPopulate,
                            owner: membershipPopulate,
                            team: {
                                populate: {
                                    owner: membershipPopulate,
                                },
                            },
                        },
                    },
                    task_types: true,
                    workspace_memberships: {
                        populate: {
                            user_roles: {
                                fields: ["role", "scope_id", "scope_type"],
                            },
                            member: {
                                populate: ["profileImage"],
                            },
                        },
                    },
                    teams: {
                        populate: {
                            owner: membershipPopulate,
                            members: membershipPopulate,
                        },
                    },
                },
            },
        },
    };
}
